export default "__VITE_ASSET__C3xuo2eS__"